import pageParams from './pageParams';

// import checkNewSession from '../../services/checkSession';

const states = {
    GAME: 'GAME',
    HIDE: 'HIDE',
    SITE: 'SITE',
};

// function getPhaserComponentInitialState() {
//     return checkNewSession() ?
//         states.GAME :
//         ((pageParams.screenSize === 'l' || pageParams.screenSize === 'xl') && states.SITE)
//         || states.HIDE;
// }

function getPhaserComponentInitialState() {
    return ((pageParams.screenSize === 'l' || pageParams.screenSize === 'xl') && states.SITE) || states.HIDE;
}

export { getPhaserComponentInitialState };
export default states;
